var _g, _g2, _rect, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 89,
    viewBox: "0 0 93 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1740_34793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 14.8952C76 13.205 65.0248 12.09 60 14.0073C60.4848 14.9889 61.4545 15.9705 62.9091 20.8785C67.9339 21.8636 76 16.5855 76 14.8952Z",
    fill: "#FF8FE0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1740_34793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 37.5597C17 28.7231 24.1634 21.5596 33 21.5596H46.5C51.5 21.5596 57.4581 21.4392 60 21.0117C63 20.5071 71 19.5413 76 15V62C76 66.4183 72.4183 70 68 70H33C24.1634 70 17 62.8366 17 54V37.5597Z",
    fill: "url(#paint0_linear_1740_34793)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1740_34793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 27,
    width: 38,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27.2089,
    width: 38,
    height: 38,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1740_34793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0029 48.0985L38.804 56.2974C38.5349 56.5665 38.22 56.701 37.8591 56.701C37.4983 56.701 37.1834 56.5665 36.9143 56.2974C36.6453 56.0284 36.5107 55.7134 36.5107 55.3526C36.5107 54.9917 36.6453 54.6768 36.9143 54.4077L45.1132 46.2088L36.9143 38.0099C36.6453 37.7409 36.5107 37.4259 36.5107 37.0651C36.5107 36.7042 36.6453 36.3893 36.9143 36.1202C37.1834 35.8512 37.4983 35.7167 37.8591 35.7167C38.22 35.7167 38.5349 35.8512 38.804 36.1202L47.0029 44.3192L55.2018 36.1202C55.4709 35.8512 55.7858 35.7167 56.1466 35.7167C56.5075 35.7167 56.8224 35.8512 57.0915 36.1202C57.3605 36.3893 57.4951 36.7042 57.4951 37.0651C57.4951 37.4259 57.3605 37.7409 57.0915 38.0099L48.8926 46.2088L57.0915 54.4077C57.3605 54.6768 57.4951 54.9917 57.4951 55.3526C57.4951 55.7134 57.3605 56.0284 57.0915 56.2974C56.8224 56.5665 56.5075 56.701 56.1466 56.701C55.7858 56.701 55.4709 56.5665 55.2018 56.2974L47.0029 48.0985Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1740_34793",
    x: 57,
    y: 10.9999,
    width: 19,
    height: 10.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1740_34793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1740_34793",
    x: 0,
    y: 0,
    width: 93,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0353423 0 0 0 0 0.024375 0 0 0 0 0.15 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1740_34793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1740_34793",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1740_34793",
    x1: 133.5,
    y1: 45.7364,
    x2: -13,
    y2: 45.7365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.267693,
    stopColor: "#7C66FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453205,
    stopColor: "#D24D98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787309,
    stopColor: "#FF4062"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ec8e92bf883cc94ad11c0dbc0cc3661a.svg";
export { ForwardRef as ReactComponent };